import { lazy } from '@loadable/component';

const BookingLanding = lazy(() =>
  import(
    /* webpackChunkName: "booking_landing" */
    './booking_landing'
  )
);

export default BookingLanding;
